import { useMutation } from '@tanstack/react-query';
import { restartTournamentRest } from '@/services/tournaments/tournaments-service';

const useRestartTournament = (tournamentId: string) => {
  const { mutate: restartTournament, isPending: isRestartingTournament } = useMutation({
    mutationFn: () => restartTournamentRest(tournamentId),
    mutationKey: ['restart-tournament', tournamentId],
  });

  return { restartTournament, isRestartingTournament };
};

export default useRestartTournament;
